'use client'

import { useEffect } from 'react'

import { normalizePostHtml } from '@/features/help-center/lib/normalize-post-html'
import { Post } from '@/features/help-center/types/post'
import { useHelpAnalytics } from '@/shared/lib/analytics'
import { Modal, ModalTitle, ModalDescription } from '@/shared/ui/Modal'

interface PostModalProps {
  post: Post
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const PostModal = ({ post }: PostModalProps) => {
  const { trackHelpPostViewed } = useHelpAnalytics()

  useEffect(() => {
    if (post) {
      trackHelpPostViewed(post)
    }
  }, [post, trackHelpPostViewed])

  if (!post) return null

  const body = normalizePostHtml(
    post.content?.trim() || post.description?.trim() || ''
  )

  return (
    <Modal className="sm:max-w-2xl">
      <div className="bg-linear-to-t from-[#E4E8FA] to-[#DDD4FF] p-4 rounded-lg flex flex-col items-start min-w-0">
        <ModalTitle className="mb-2 w-full break-words">{post.name}</ModalTitle>
        {body ? (
          <ModalDescription
            className="text-sm prose w-full text-american-blue break-words"
            dangerouslySetInnerHTML={{ __html: body }}
          />
        ) : (
          <ModalDescription className="text-sm w-full text-american-blue break-words">
            Este conteúdo ainda não está disponível.
          </ModalDescription>
        )}
      </div>
    </Modal>
  )
}
